import * as types from './mutations_type';

export default {
  init_user_data: ({ commit }, user_data) => {
    commit(types.USERDATA, user_data);
  },
  change_router_name: ({ commit }, router_name ) => {
    commit(types.ROUTERNAME, router_name);
  },

  setRooms({commit}, room){
    commit('ROOMS', room);
  },

  setAdults({commit}, adult){
    commit('ADULTS', adult);
  },

  setChildren({commit}, children){
    commit('CHILDREN', children);
  },

  setAges({commit}, ages){
    commit('AGES', ages)
  },
}



// WEBPACK FOOTER //
// ./src/store/actions.js